import { createContext, useContext } from "react";
import type { MapCoreApi } from "../core/api";

export const CoreContext = createContext<MapCoreApi | null>(null);

export function useMapCore(): MapCoreApi {
  const core = useContext(CoreContext);

  if (core === null) throw new Error("ForteXMap components must be rendered inside <ForteXMap> or <MapCoreProvider>");

  return core;
}

export function useOptionalMapCore(): MapCoreApi | null {
  return useContext(CoreContext);
}
